import "./Login.css";
import React from "react";
import { connect } from "react-redux";
import { setUser } from "../../ducks/Auth";
import { db, auth } from "../../services/firebase";
import { default as LoginForm } from "../../forms/LoginForm";
import NotificationSystem from "react-notification-system";
import logo_integrar from "../../assets/img/logo_integrar.png";
import { style as NotifyStyle } from "../../variables/Variables.jsx";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    return (
      <div className="login__container">
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <div className="login__form">
          <div className="login__logo-container">
            <img className="login__logo" src={logo_integrar} alt="react-logo" />
          </div>
          <LoginForm
            loading={this.state.loading}
            onSubmit={this._handleSubmit}
          />
        </div>
      </div>
    );
  }

  _handleSubmit = (values) => {
    this.setState({ loading: true });
    const { email, password } = values;
    auth
      .signInWithEmailAndPassword(email, password)
      .then((user) => {
        db.collection("users")
          .doc(user.uid)
          .get()
          .then((userSnapshot) => {
            if (userSnapshot.exists) {
              const PromiseStack = [];
              const userData = { ...userSnapshot.data() };

              if (userSnapshot.data().shift) {
                PromiseStack.push(
                  db
                    .collection("companies")
                    .doc(userSnapshot.data().company)
                    .collection("shifts")
                    .doc(
                      userSnapshot.data().shift
                        ? userSnapshot.data().shift
                        : userSnapshot.data().shift.value
                    )
                    .get()
                    .then((snap) => (userData.shiftName = snap.data().name))
                    .catch((e) => console.log(e))
                );
              }

              if (userSnapshot.data().company) {
                PromiseStack.push(
                  db
                    .collection("companies")
                    .doc(userSnapshot.data().company)
                    .get()
                    .then((snap) => (userData.companyName = snap.data().name))
                    .catch((e) => console.log(e))
                );
              }

              PromiseStack.push(
                db
                  .collection("roles")
                  .doc(userSnapshot.data().role)
                  .get()
                  .then((snap) => (userData.roleName = snap.data().name))
                  .catch((e) => console.log(e))
              );

              Promise.all(PromiseStack)
                .then(() => {
                  if (userData.roleName === "Coletor") {
                    this.notify(
                      "Este usuário não tem acesso ao painel",
                      "error"
                    );
                    this.setState({ loading: false });
                  } else {
                    this.props.setUser(userData);
                    this.setState({ loading: false });
                  }
                })
                .catch((e) => {
                  this.notify("Erro ao buscar dados do usuário", "error");
                  this.setState({ loading: false });
                });
            } else {
              this.notify("Erro ao buscar dados do usuário", "error");
              this.setState({ loading: false });
            }
          })
          .catch((e) => {
            console.log(e);
            this.notify("Não foi possível encontrar o usuário", "error");
            this.setState({ loading: false });
          });
      })
      .catch((e) => {
        this.setState({ loading: false });
        switch (e.code) {
          case "auth/user-not-found":
            return this.notify("Este usuário não existe", "error");
          case "auth/invalid-email":
            return this.notify("Email inválido", "error");
          case "auth/wrong-password":
            return this.notify("Senha incorreta", "error");
          case "auth/user-disabled":
            return this.notify(
              "Seu usuário foi desativado pela Integrar",
              "error"
            );
          case "auth/network-request-failed":
            return this.notify(
              "Você está sem internet. Verifique sua conexão",
              "error"
            );
          default:
            return this.notify("Erro ao autenticar", "error");
        }
      });
  };

  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };
}

export default connect(null, { setUser })(Login);



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx